<template>
  <div>
      <h1>{{$t('Footer.Privacy')}}</h1>
      <p class="mt-5">{{ $t('Imprint.adbonlineisasubdomainfrombbl') }}</p>
      <p><a class="underline" href="https://www.boersenblatt.net/datenschutzinformationen" target="_blank" rel="noopener">{{ $t('Imprint.link.to.mvbprivacy') }}</a></p>      
  </div>
</template>